export const environment = {
  production: true,
  baseUrl: "https://xxlist.kr",
  kakaoAppKey: "817d392bc09e745b075aa13978eb8825",
  nhn: {
    objectStorageContainer: "test",
  },
};
